jQuery(document).ready(function ($) {



/*** MINI CART ***/

$(document).on("click", ".submit_form", function(e) {
  e.preventDefault();

  var $button = $(this);
  var $form = $button.closest("form");
  var variantId = $form.find('[name="id"]').val() || $button.attr("data-pro-id");

  if (!variantId) {
    console.error("Variant ID not found");
    return;
  }

  $.ajax({
    type: "POST",
    url: window.Shopify.routes.root + "cart/add.js",
    data: JSON.stringify({
      id: Number(variantId),
      quantity: 1
    }),
    dataType: "json",
    contentType: "application/json",
    success: function(data) {
      var url = new URL(window.location.href);
      url.searchParams.set("open_cart", "1");
      window.location.href = url.toString();
    },
    error: function(xhr, status, error) {
      console.error("Add to cart error:", error);
      console.error(xhr.responseText);
    }
  });
});


const params = new URLSearchParams(window.location.search);
if (params.get('open_cart') === '1') {
   const cartToggle = document.querySelector('#cart-icon-bubble');
    if (cartToggle) {
      cartToggle.click();
  }
  params.delete('open_cart');
  history.replaceState({}, '', `${location.pathname}?${params}`);
}

/*** MINI CART ***/

  $('.button--secondary[href="#form"], a.button.button--primary[href="#form"]').on('click', function(e) {
    e.preventDefault();
    $('html, body').animate({
        scrollTop: $('.nt_bereit').offset().top - 80
    }, 0);
  });
  
  // if (window.location.hash === '#form' && $('.nt_bereit').length) {
  //   setTimeout(function () {
  //       $('html, body').animate({
  //           scrollTop: $('.nt_bereit').offset().top - 80
  //       }, 0);
  //   }, 0); 
  // }
  $('.nt_vorteile_der .multicolumn-card__info h3.inline-richtext').click(function (e) { 
      e.preventDefault();
      $(this).closest('.multicolumn-list__item').toggleClass('active');
  });
  $('.dropdown-faq-btn').click(function (e) { 
      e.preventDefault();
      $('.dropdown-faq').toggleClass('active');
  });
  $('.dropdown-blog-btn').click(function (e) { 
      e.preventDefault();
      $(this).toggleClass('active');
  });
  $('.text-review, .product__info-wrapper.grid__item .rating-wrapper').on('click', function() {
      $('html, body').animate({
          scrollTop: $('#judgeme_product_reviews').offset().top - 180
      }, 500);
  });
  $(document).on('click', '[data-pagination-link]', function(e) {
    e.preventDefault();
    const $button = $(this);
    const nextUrl = $button.attr('href');

    $button.text("Laden...");
    $button.prop('disabled', true);

    $.get(nextUrl, function(response) {
        const $tempDiv = $('<div>').html(response);
        const newProductsHtml = $tempDiv.find('#product-grid').html();
        const $newButton = $tempDiv.find('[data-pagination-link]');
        
        $('ul#product-grid').append(newProductsHtml);
        $button.closest('.show_more_btn').remove(); // remove old button wrapper

        if ($newButton.length) {
            $('ul#product-grid').after($newButton.closest('.show_more_btn')); // add new button wrapper
        }
    }).fail(function() {
        console.error('Error loading more products.');
        $button.text("Try again");
        $button.prop('disabled', false);
    });
  });

  $('#verticalTitle').click(function() {
        $(this).toggleClass('active');
        $('.facets__form-vertical,#ProductGridContainer').toggleClass('facets__form-vertical_show');
    });
    $('form#FacetFiltersForm button.button.button--primary').click(function() {
        $('.facets__form-vertical,#ProductGridContainer').toggleClass('facets__form-vertical_show');
    });

  $(document).on('click', '.acc-add_ons', function (e) {
    e.preventDefault();
    e.stopPropagation();

    const targetId = $(this).data('id');
    const html = $(this).find('span').html();
    const $target = $('#' + targetId);
    $('span#selected-option').html(html);
    if ($target.length) {
      $('html, body').stop().animate({
        scrollTop: $target.offset().top - 150
      }, 500);
    }
  });
  $('.testimonials-down').click(function (e) { 
      e.preventDefault();
      $(this).hide();
      $('.testimonials-slider').toggleClass('testimonials-lm');
  });
  $('.blog_slider .grid').flickity({
        imagesLoaded: true,
        groupCells: false,
        dragThreshold: 5,
        cellAlign: 'left',
        wrapAround: true,
        prevNextButtons: true,
        percentPosition: true,
        pageDots: false,
        rightToLeft: false,
        autoPlay: false,
        groupCells: true,
        adaptiveHeight: true
    });
  $('footer .has-dropdown .footer-block__heading').click(function (e) { 
    e.preventDefault();
    $(this).toggleClass('active');
  });
  $('.nt_seo .rich-text_details-content').click(function (e) { 
    e.preventDefault();
    $(this).closest('.nt_seo').toggleClass('active');
  });
  function slider_mobile() {
    if($(window).width() <= 949){ 
      const $product__media = $(".grid__item.product__media-wrapper .slider-pdp .grid").flickity({
        imagesLoaded: true,
        groupCells: false,
        dragThreshold: 5,
        cellAlign: 'center',
        wrapAround: true,
        prevNextButtons: true,
        percentPosition: true, 
        pageDots: false,
        rightToLeft: false,
        autoPlay: false,
        sync: ' .product-single__thumbnails'
      });
      $(".slider-pdp ul.thumbnails-wrapper.background-modal").flickity({
        pageDots: false,
        // freeScroll: false,
        // wrapAround: true,
        prevNextButtons: false,
        autoPlay: false,
        groupCells: true,
        cellAlign: 'left',
        asNavFor: '.grid__item.product__media-wrapper .slider-pdp .grid'
    });
  
      const $collection_featured = $(".nt_anders .static-items.col-5").flickity({
          prevNextButtons: false,
          groupCells: true,
          cellAlign: 'left',
          contain: true,
          pageDots: false,
          autoPlay: 6000
      });
      const $nt_entdecke = $(".nt_entdecke.nt_entdecke-2.multicolumn .multicolumn-list").flickity({
          prevNextButtons: true,
          // groupCells: true,
          cellAlign: 'left',
          contain: true,
          pageDots: false,
          autoPlay: 6000
      });
      var swiper = new Swiper('.testimonials-slider:not(.list_mobi, .testimonials-slider-blog)', { 
        slidesPerView: 1,
        spaceBetween:20,
        loop: true,
        centeredSlides: true,
        // pagination: {
        //   el: ".testimonials-slider .swiper-pagination",
        // },
         navigation: {
          nextEl: '.testimonials-slider .swiper-button-next-ct',
          prevEl: '.testimonials-slider .swiper-button-prev-ct',
        },
        autoplay: {
          delay: 50000,
          disableOnInteraction: false,
        }
      });
    }
  }
  $(document).ready(slider_mobile);
  $(window).on('resize', function() {
    slider_mobile();
  });

 
  $('.acc-head').on('click', function() {
    if($(this).hasClass('active')) {
      $(this).siblings('.acc-content').slideUp();
      $(this).removeClass('active');
    }
    else {
      $('.acc-content').slideUp();
      $('.acc-head').removeClass('active');
      $(this).siblings('.acc-content').slideToggle();
      $(this).toggleClass('active');
    }
  });
});
// load varaint 
window.addEventListener("load", function () {
  const header = document.querySelector('.shopify-section-header-sticky');
  if (!header) return;

  function checkScroll() {
    header.classList.toggle('is-scrolled', window.scrollY > 0);
  }

  checkScroll();
  window.addEventListener('scroll', checkScroll);
});

document.addEventListener('DOMContentLoaded', function () {
  function addKiBadges(scope = document) {
    const images = scope.querySelectorAll('#MainContent img[alt*="[AI]"]');

    images.forEach(function (img) {
      if (img.dataset.kiBadge === 'true') return;

      const parent = img.parentElement;
      if (!parent) return;

      parent.classList.add('ki-image-wrapper');

      const badge = document.createElement('span');
      badge.className = 'ki-image-badge';
      badge.textContent = 'KI';

      if (img.alt.toLowerCase().includes('[ai] white')) {
        badge.classList.add('ki-image-badge--white');
      }

      parent.appendChild(badge);

      img.dataset.kiBadge = 'true';
    });
  }

  addKiBadges();

  const observer = new MutationObserver(function () {
    addKiBadges();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});


document.addEventListener('fullscreenchange', function () {
  document.querySelectorAll('.video-section__media.media-fit-cover video').forEach(wrapper => {
    wrapper.classList.toggle(
      'is-fullscreen',
      document.fullscreenElement === wrapper
    );
  });
  document.querySelectorAll('.fitmacher-tv__video').forEach(wrapper => {
    wrapper.classList.toggle(
      'is-fullscreen',
      document.fullscreenElement === wrapper
    );
  });
  document.querySelectorAll('.video-player').forEach(wrapper => {
    wrapper.classList.toggle(
      'is-fullscreen',
      document.fullscreenElement === wrapper
    );
  });
});


setTimeout(() => {
  document.querySelectorAll('.sl-h-1').forEach(element => {
    element.classList.add('active');
  });
}, 7000);